import { render, staticRenderFns } from "./ChartDatapointLabel.vue?vue&type=template&id=21e248c8&"
import script from "./ChartDatapointLabel.vue?vue&type=script&lang=js&"
export * from "./ChartDatapointLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports